import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./newsroom.css";

const ArticleEditorPage = lazy(() => import("./article").then((m) => ({ default: m.ArticleEditorPage })));
const DraftEditorPage = lazy(() => import("./drafted").then((m) => ({ default: m.DraftEditorPage })));
const DraftedPage = lazy(() => import("./drafted").then((m) => ({ default: m.DraftedPage })));
const WritingGuidePage = lazy(() => import("./guide").then((m) => ({ default: m.WritingGuidePage })));
const KeywordDetailPage = lazy(() => import("./keywords").then((m) => ({ default: m.KeywordDetailPage })));
const KeywordsPromptsPage = lazy(() => import("./keywords").then((m) => ({ default: m.KeywordsPromptsPage })));
const PromptDetailPage = lazy(() => import("./keywords").then((m) => ({ default: m.PromptDetailPage })));
const ArticlesPage = lazy(() => import("./list").then((m) => ({ default: m.ArticlesPage })));
const ArticlePerformancePage = lazy(() => import("./performance").then((m) => ({ default: m.ArticlePerformancePage })));
const ContentPlanPage = lazy(() => import("./plan").then((m) => ({ default: m.ContentPlanPage })));
const NewsroomSettingsSection = lazy(() => import("./settings").then((m) => ({ default: m.NewsroomSettingsSection })));

/**
 * Newsroom: the business's articles on its members' site, the content plan, the keywords and prompts it writes
 * with, AI drafts waiting for a person, and the writing guide.
 */

export const routes: SolutionRoute[] = [
  { solution: "newsroom", path: "newsroom", element: <ArticlesPage /> },
  { solution: "newsroom", path: "newsroom/plan", element: <ContentPlanPage /> },
  { solution: "newsroom", path: "newsroom/keywords", element: <KeywordsPromptsPage /> },
  { solution: "newsroom", path: "newsroom/keywords/search", element: <KeywordDetailPage /> },
  { solution: "newsroom", path: "newsroom/keywords/prompts/:id", element: <PromptDetailPage /> },
  { solution: "newsroom", path: "newsroom/drafted", element: <DraftedPage /> },
  { solution: "newsroom", path: "newsroom/drafted/:id", element: <DraftEditorPage /> },
  { solution: "newsroom", path: "newsroom/guide", element: <WritingGuidePage /> },
  { solution: "newsroom", path: "newsroom/:id/performance", element: <ArticlePerformancePage /> },
  { solution: "newsroom", path: "newsroom/:id", element: <ArticleEditorPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "newsroom", key: "newsroom", label: "Newsroom", icon: Icon.doc, need: "newsroom.view", Component: NewsroomSettingsSection }];

/** The sidebar entry (already in nav.ts; kept here so the paths stay together). */
export const nav: NavItem = {
  to: "/newsroom", label: "Newsroom", icon: Icon.doc, solution: "newsroom", need: "newsroom.view",
  subs: [{ to: "/newsroom/plan", label: "Content plan" }, { to: "/newsroom/drafted", label: "Drafted" }, { to: "/newsroom/keywords", label: "Keywords" }],
};
